import React from 'react';
import ReactLoadingOverlay from 'react-loading-overlay';

export interface LoadingOverlayProps {   
    show?: boolean;
    message?: string | null;
}

export const LoadingOverlay: React.FC<LoadingOverlayProps> = (props) => {   
    return (        
        <ReactLoadingOverlay spinner active={props.show} text={props.message || undefined}>{props.children}</ReactLoadingOverlay>            
    )
}

(LoadingOverlay as any).displayName = 'LoadingOverlay';